const config = require("./config.json");

const envMode = "prod";

const BASE_URL = config[envMode].BASEURL;

module.exports = { envMode, BASE_URL };
